var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2173",
    d: "M8.41663 1.66669H8.6439C11.3616 1.66669 12.7204 1.66669 13.6641 2.33155C13.9344 2.52204 14.1745 2.74796 14.3769 3.00243C15.0833 3.89058 15.0833 5.16948 15.0833 7.72729V9.84851C15.0833 12.3178 15.0833 13.5525 14.6925 14.5386C14.0643 16.1238 12.7357 17.3743 11.0513 17.9656C10.0036 18.3334 8.69178 18.3334 6.06814 18.3334C4.56892 18.3334 3.81931 18.3334 3.22061 18.1232C2.25812 17.7853 1.49892 17.0708 1.13993 16.1649C0.916626 15.6014 0.916626 14.8959 0.916626 13.4849V10",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0833 10C15.0833 11.5341 13.8397 12.7778 12.3056 12.7778C11.7507 12.7778 11.0966 12.6806 10.5572 12.8251C10.0779 12.9535 9.70353 13.3279 9.5751 13.8072C9.43056 14.3466 9.52778 15.0007 9.52778 15.5556C9.52778 17.0897 8.28412 18.3333 6.75 18.3333",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.75 6.25004C2.15961 6.67146 3.24981 8.33337 3.83333 8.33337M5.91667 6.25004C5.50706 6.67146 4.41686 8.33337 3.83333 8.33337M3.83333 8.33337L3.83333 1.66671",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.d92b64ba72a22feb7db7a1d5a3dea5d4.svg";
export { ForwardRef as ReactComponent };